export const STATUS_INCOMPLETE = 'incomplete';
export const STATUS_COMPLETED = 'completed';
export const STATUS_INCOMPLETE_OVERDUE = 'incomplete-overdue';
export const STATUS_COMPLETED_OVERDUE = 'completed-overdue';

export const Checkpoint = {
  isCompleted: (status) => [STATUS_COMPLETED, STATUS_COMPLETED_OVERDUE].includes(status),
  isOverdue: (status) => [STATUS_INCOMPLETE_OVERDUE, STATUS_COMPLETED_OVERDUE].includes(status),
};
